import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { twMerge } from "tailwind-merge";
import { Dialog } from "./Dialog";
import { DepositWithdrawModal } from "~/features/bank/components/DepositWithdrawModal";
import type { PriceType } from "../types";

const usdcIcon = new URL('../assets/usdc.png', import.meta.url).toString()
const pointIcon = new URL('../assets/point.png', import.meta.url).toString()

const mapping = {
    'USDC': usdcIcon,
    'POINT': pointIcon,
}

export interface PriceProps {
    price: PriceType
    disabled?: boolean;
    showDepositIcon?: boolean;
}

export const Price = ({ price, disabled, showDepositIcon }: PriceProps) => {
    const currency = price.currency
    const value = price.price
    const canDeposit = currency.toUpperCase() === 'USDC'

    return <div className="inline-flex items-center gap-1 font-bold" >
        {canDeposit && !!showDepositIcon && <Dialog>
            <Dialog.Trigger><button className="text-2xl text-green-500 hover:scale-110 px-2" title="Deposit"><FontAwesomeIcon icon={faPlusSquare} /></button></Dialog.Trigger>
            <Dialog.Content>
                <DepositWithdrawModal action="deposit" />
            </Dialog.Content>
        </Dialog>}
        <img src={mapping[currency.toUpperCase()]} alt={currency} title={currency} className={twMerge("h-6 w-auto", !!disabled && "opacity-20")} />
        <span className={twMerge(!!disabled && "opacity-20")}>{value}</span>
    </div>;
}